import { adminHttpClient } from '../../../../commons/adminHttpClinet';
import { EditAffiliateModel } from '../../../../models/dashboard/marketplace/editAffiliateModel';

const updateAffiliate = (model: EditAffiliateModel) => {
    return adminHttpClient.put("/api/Admin/AdminMarketplace/update-marketplace", model);
}
export default updateAffiliate;